module.exports = function () { /* empty */ };



//////////////////
// WEBPACK FOOTER
// ./~/_core-js@2.6.9@core-js/library/modules/_add-to-unscopables.js
// module id = WkkM
// module chunks = 0